import { CLUB_GALLERY } from "@/data/clubMedia";

export default function ClubGallery() {
  // Triple the array for a seamless loop
  const list = [...CLUB_GALLERY, ...CLUB_GALLERY, ...CLUB_GALLERY];

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative py-32 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 mb-14">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#FFB800] mb-6 flex items-center gap-3">
              <span className="h-px w-10 bg-[#FFB800]" />
              02 — Galería
            </p>
            <h2 className="font-display text-4xl md:text-6xl lg:text-7xl font-extrabold uppercase tracking-tight leading-[0.95]">
              El club<br />
              <span className="italic font-light text-white/70">en imágenes.</span>
            </h2>
          </div>

          <p className="text-white/55 max-w-sm text-[15px]">
            Vestuario, partidos, calentamientos. Una década escrita con
            fotografías que cuentan quiénes somos.
          </p>
        </div>
      </div>

      {/* Continuous, gapless marquee */}
      <div className="overflow-hidden mx-6 md:mx-10 lg:mx-16 rounded-[2.5rem] border border-white/10">
        <div
          className="flex marquee-track-slow"
          style={{ width: "max-content" }}
          data-testid="gallery-track"
        >
          {list.map((g, i) => (
            <div
              key={i}
              data-testid={`gallery-slide-${i}`}
              className="relative flex-shrink-0 h-[360px] md:h-[460px] lg:h-[520px] aspect-[4/5] overflow-hidden bg-[#0A1121]"
            >
              <img
                src={g.src}
                alt={g.caption}
                loading="lazy"
                className="w-full h-full object-cover"
                draggable={false}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#030712]/70 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between gap-3">
                <p className="font-display text-lg md:text-xl font-bold uppercase tracking-tight text-white">
                  {g.caption}
                </p>
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/70 bg-[#030712]/40 backdrop-blur rounded-full px-2.5 py-1 border border-white/10">
                  {String((i % CLUB_GALLERY.length) + 1).padStart(2, "0")}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
